// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_kGp","cls2":"ReferenceCard-cls2_8XX ReferenceCard-cls1_kGp"};